<template>
    <div class="linear-gradient-v-1093FF-to-69BBFF">
        <tool-bar :arrow="require('../../assets/icon_nav_white.png')"
                  title="USSD"
                  title-color="#FFFFFF"></tool-bar>

        <div class="font-bold font-16 color-FFFFFF margin-t-50" style="text-align: center">
            <div>Scan the QR code below through></div>
            <div>your Ecobank, FirstBank, Fidelity,</div>
            <div>Access, Diamond or Zenith Bank</div>
            <div>moblie app to complete the payment.</div>
        </div>

        <div class="margin-t-41 flex-h flex-h-center">
            <div class="bg-FFFFFF radius-15 flex-h flex-h-center flex-v-center" style="height: 210px;width: 210px;">
                <vue-qr ref="qr" :size="180" :margin="5"
                        :text="payInfo.url"></vue-qr>
            </div>
        </div>

        <div class="flex-h flex-h-center margin-t-22 padding-b-90">
            <div class="w-150 radius-19 bg-1477FE color-FFFFFF font-bold font-16"
                 style="text-align: center;display: inline-block;line-height: 38px;" @click="downloadQR()">
                Save QR code
            </div>
        </div>

        <div class="bg-FFFFFF h-71 flex-v flex-h-center" style="position: fixed;bottom: 0;width: 100%">
            <div class="padding-h-15">
                <van-button style="font-size: 19px;border-radius: 8px;height: 55px;"
                            color="linear-gradient(to right,#1093FF, #69BBFF)"
                            @click="toPayResult()"
                            block>
                    I’ve completed the transaction
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "repayment_qr",
        data() {
            return {
                money: 737,
                payInfo: {
                    id: '',
                    url: ''
                }
            };
        },
        mounted() {
            let payInfoStr = this.$route.query.payInfo
            if (payInfoStr) {
                this.payInfo = JSON.parse(payInfoStr)
            }
        },
        beforeRouteEnter(to, from, next) {
            // 添加背景色
            document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
            next()
        },
        beforeRouteLeave(to, from, next) {
            //去除背景色
            document.querySelector('body').setAttribute('style', '')
            next()
        },
        methods: {
            /**
             * 下载一码付二维码
             * @author YJX
             * @date 2019-06-13 15:12
             **/
            downloadQR() {
                let a = document.createElement('a');
                // 下载图名字
                a.download = "qr-" + new Date().getTime() + '.jpg';
                //url
                a.href = this.$refs.qr.$el.src;
                //合成函数，执行下载
                a.dispatchEvent(new MouseEvent('click'))
            },
            toPayResult() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>

</style>